const getLiveHourInfo = (rulesetDetail, agency) => {
  const startHourNormalDay = parseInt(rulesetDetail?.normalStart?.slice(0, 2));
  const hoursNormalDay = [startHourNormalDay, startHourNormalDay + rulesetDetail?.liveHours];

  const startHourEventDay = parseInt(rulesetDetail?.paydayStart?.slice(0, 2));
  const hoursEventDay = [startHourEventDay, startHourEventDay + rulesetDetail?.paydayLiveHours];

  let agencyNormalHours = null;
  let agencyPaydayHours = null;

  if (agency) {
    agencyNormalHours = [parseInt(agency?.agencyNormalStart?.slice(0.2)), parseInt(agency?.agencyNormalEnd?.slice(0.2))];
    agencyPaydayHours = [parseInt(agency?.agencyPaydayStart?.slice(0.2)), parseInt(agency?.agencyPaydayEnd?.slice(0.2))];
  }

  return {
    hoursNormalDay,
    hoursEventDay,
    agencyNormalHours,
    agencyPaydayHours,
  };
};

export default getLiveHourInfo;
